import { Button } from '@components/button';
import { ButtonGroup } from '@components/button-group';
import { IconFormIndicatorWarning } from '@components/icons/form-indicator-warning';
import { Modal, hideModal, useModal } from '@components/modal';
import { useScopedTranslate } from '@locale/translate';

export const useDeleteBlockedModal = () => useModal(DeleteBlockedModal);

type CannotDeleteModalProps = {
  description: string;
};

const DeleteBlockedModal = ({ description }: CannotDeleteModalProps) => {
  const { t } = useScopedTranslate(locale);
  return (
    <Modal>
      <Modal.SimpleHeader title={t('title')} icon={<IconFormIndicatorWarning />} />
      <Modal.Content>{description}</Modal.Content>
      <Modal.Footer>
        <ButtonGroup align="right">
          <Button variant="secondary" onClick={hideModal} text={t('close')} />
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};
export const locale = {
  en: {
    title: 'Delete not available',
    close: 'Close',
  },
};
